import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewFullTeamAssessmentComponent } from '../../../../components/review-content/review-full-team-assessment/review-full-team-assessment.component';
import { CommonModule } from '@angular/common';
import { IFullTeamAssessment } from '../../../../../shared/models/fullTeamAssessment';

@Component({
  selector: 'full-team-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewFullTeamAssessmentComponent
  ],
  templateUrl: './full-team-submission.component.html',
  styleUrl: './full-team-submission.component.css'
})
export class FullTeamSubmissionComponent implements OnInit {

  @Input() fullTeamAssessmentData: IFullTeamAssessment | null = null;
  @Output() onSaveSection18 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.fullTeamAssessmentData) {
      this.currentCaseId = this.fullTeamAssessmentData.case_id;
    }
  }

  submitFullTeamAssessment(): void {
    this.onSaveSection18.emit({});
  }
}
